<template>
	<v-card elevation="0">
		<v-card-title class="text-left card-header fixed-card-title2">
			<v-row no-gutters>
				<v-col>
					<v-toolbar-title>{{ $t('add') }} {{ $t('consumable-catalog') }}</v-toolbar-title>
				</v-col>
				<v-spacer />
				<v-icon color="white" @click="closeDrawer">mdi-close</v-icon>
			</v-row>
		</v-card-title>
		<v-card-text class="pa-4 pb-0 overflow-y-auto" style="height: calc(100vh - 122px)">
			<v-row dense>
				<v-col cols="12">
					<v-select
						dense
						v-model="itemModel.category"
						:items="inventoryConsumableCategoryOptions"
						:label="$t('category')"
						hide-details
						outlined
						item-value="code"
						item-text="code"
						:menu-props="{ offsetY: true }" />
				</v-col>
				<v-col cols="12">
					<v-text-field dense hide-details outlined :label="$t('name')" v-model="itemModel.name" />
				</v-col>
				<v-col cols="12">
					<v-text-field dense hide-details outlined :label="$t('manufacturer')" v-model="itemModel.manufacturer" />
				</v-col>
				<v-col cols="12">
					<v-text-field
						dense
						hide-details
						outlined
						:label="$t('internal-product-code')"
						v-model="itemModel.internalProductCode" />
				</v-col>
				<v-col cols="12">
					<v-select
						dense
						v-model="itemModel.unitOfMeasure"
						:items="inventoryConsumableUnitOfMeasureOptions"
						:label="$t('unit-of-measure')"
						hide-details
						outlined
						item-value="code"
						item-text="code"
						:menu-props="{ offsetY: true }" />
				</v-col>
				<v-col cols="12">
					<v-text-field
						dense
						hide-details
						outlined
						@keypress="(e) => /[0-9]/.test(e.key) || e.preventDefault()"
						:label="$t('min-stock-threshold')"
						v-model="itemModel.minStockThreshold" />
				</v-col>
				<v-col cols="12">
					<v-textarea rows="5" dense hide-details no-resize outlined :label="$t('notes')" v-model="itemModel.notes" />
				</v-col>
			</v-row>
		</v-card-text>
		<v-container class="px-4">
			<v-row dense>
				<v-col cols="6" order="1">
					<v-btn elevation="0" class="cancel-button-style capitalize-text" @click="closeDrawer">
						{{ $t('cancel') }}
					</v-btn>
				</v-col>
				<v-col cols="6" order="2">
					<v-btn block color="primary" :disabled="!isSaveButtonDisabled" @click="addConsumable">{{ $t('save') }}</v-btn>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
	name: 'AddInventoryConsumable',
	data () {
		return {
			loading: false,
			itemModel: {
				name: '',
				manufacturer: '',
				internalProductCode: '',
				unitOfMeasure: '',
				minStockThreshold: 0,
				notes: '',
				category: '',
			},
			inventoryConsumableCategoryOptions: [],
			inventoryConsumableUnitOfMeasureOptions: [],
		};
	},
	methods: {
		...mapActions({
			getInventoryConsumableCategoryOptions: 'inventoryConsumableCatalogs/getInventoryConsumableCategoryOptions',
			getInventoryUnitOfMeasureOptions: 'inventoryConsumableCatalogs/getInventoryUnitOfMeasureOptions',
			addConsumableCatalog: 'inventoryConsumableCatalogs/addConsumableCatalog',
		}),
		closeDrawer () {
			this.itemModel = {
				name: '',
				manufacturer: '',
				internalProductCode: '',
				unitOfMeasure: '',
				minStockThreshold: 0,
				notes: '',
			};
			this.$store.commit('SET_DETAIL_DRAWER_STATE', false);
			this.$store.commit('SET_DETAILS_DRAWER', false);
		},
		async addConsumable () {
			const resultAdd = await this.addConsumableCatalog(this.itemModel);
			if (resultAdd) {
				this.closeDrawer();
			}
		},
		async getCategoriesAndUnitOfMeasure () {
			const resultCategory = await this.getInventoryConsumableCategoryOptions();
			this.inventoryConsumableCategoryOptions = resultCategory;

			const resultUnitOfMeasure = await this.getInventoryUnitOfMeasureOptions();
			this.inventoryConsumableUnitOfMeasureOptions = resultUnitOfMeasure;
		},
	},
	computed: {
		headers () {
			return [{ text: this.$t('name'), value: 'firstName' }];
		},
		isSaveButtonDisabled () {
			return (
				this.itemModel.name.trim() !== '' &&
				this.itemModel.manufacturer.trim() !== '' &&
				this.itemModel.internalProductCode.trim() !== '' &&
				this.itemModel.unitOfMeasure.trim() !== '' &&
				this.itemModel.minStockThreshold >= 0
			);
		},

		...mapState({
			detailsDrawer: (state) => state.detailsDrawer,
			updateDrawer: (state) => state.updateDrawer,
		}),
	},
	async mounted () {
		await this.getCategoriesAndUnitOfMeasure();
	},
	watch: {
		async detailsDrawer (val) {
			if (val) {
				await this.getCategoriesAndUnitOfMeasure();
			}
		},
	},
};
</script>
